import { useEffect } from "react";

/**
 * Hook that triggers a callback when the page visibility changes from hidden to visible.
 * Useful for refreshing data when a PWA app is brought back to focus from the background.
 *
 * @param onVisible - Callback function to execute when the page becomes visible
 * @param enabled - Whether the hook is enabled (default: true)
 */
export function useVisibilityRefresh(onVisible: () => void, enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return;

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Page has become visible
        onVisible();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onVisible, enabled]);
}
